import { TextAreaProps } from 'antd/es/input';
import styled from 'styled-components';
import { Input, InputBackgroundColor, InputBorder, InputFocus } from './input';
import { Short01 } from '../../styles';

export const TextArea = styled(Input.TextArea)<TextAreaProps>`
  padding: var(--spacing-04) var(--spacing-05);
  background-color: ${InputBackgroundColor};
  resize: none;
  ${Short01};
  ${InputBorder};
  &:focus {
    ${InputFocus};
  }
  &.ant-input[disabled] {
    color: var(--text-disabled);
  }
`;
